import React, { useCallback, useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { ContainerClients } from './style.js';

import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import SelectDefault from '../../../components/SelectDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';

const FlagEconmomyAdd = () => {
  document.title = 'Datamais - Cadastrar Economia de Bandeira';

  const navigate = useNavigate();

  const [idDm003, setIdDm003] = useState(0);
  const [idDm003List, setIdDm003List] = useState(0);
  const [idDm004, setIdDm004] = useState(0);
  const [idDm004List, setIdDm004List] = useState(0);
  const [prDesconto, setPrDesconto] = useState('');

  const handleSendFlagEconomy = useCallback(async () => {
    const data = {
      ID_DM003: parseInt(idDm003),
      ID_DM004: parseInt(idDm004),
      PR_DESCONTO: parseFloat(prDesconto.replace(',', '.'))
    };
    api
      .post(`flag_economy`, data)
      .then((response) => {
        if (response.status === 201) {
          toast.success('Cadastrar Economia de Bandeira', {
            autoClose: 3000,
            onClose: () => {
              navigate('/flag_economy/list');
            }
          });
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error.response.data.error);
        toast.error(error.response.data.message);
      });
  }, [idDm004, idDm003, prDesconto]);

  useEffect(() => {
    api
      .get(`energy_flag`)
      .then((response) => {
        if (response.status === 200) {
          setIdDm004List(response.data.data);
          setIdDm004(response.data.data[0].ID_DM004);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    api
      .get(`supplier?situacao=A`)
      .then((response) => {
        if (response.status === 200) {
          setIdDm003List(response.data.data);
          setIdDm003(response.data.data[0].ID_DM003);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <AuthGuard />
      <Container>
        <Menu />
        <ContainerClients>
          <h2>Cadastrar Economia de Bandeira</h2>
          <Row>
            <div
              style={{
                border: '1px solid',
                borderRadius: '10px',
                marginTop: '30px'
              }}>
              <p
                style={{
                  marginTop: '-12px',
                  background: '#f1f1f1',
                  display: 'table',
                  padding: '0px 5px 0px 5px'
                }}>
                Dados da Tarifa
              </p>
              <Row>
                <Col xs={3}>
                  <SelectDefault
                    Text="Bandeira"
                    Margin={'15px 15px 15px 0px'}
                    Width={'100%'}
                    value={idDm004}
                    onChange={(e) => setIdDm004(e.target.value)}>
                    {idDm004List && idDm004List.length > 0 ? (
                      idDm004List.map((item) => (
                        <option key={item.ID_DM004} value={item.ID_DM004}>
                          {item.NM_BANDEIRA} ({item.ID_DM004})
                        </option>
                      ))
                    ) : (
                      <option disabled>Carregando lista...</option>
                    )}
                  </SelectDefault>
                </Col>
                <Col xs={3}>
                  <SelectDefault
                    Text="Distribuidora"
                    Margin={'15px 15px 15px 0px'}
                    Width={'100%'}
                    value={idDm003}
                    onChange={(e) => setIdDm003(e.target.value)}>
                    {idDm003List && idDm003List.length > 0 ? (
                      idDm003List.map((item) => (
                        <option key={item.ID_DM003} value={item.ID_DM003}>
                          {item.NM_DISTRIBUIDORA} ({item.ID_DM003})
                        </option>
                      ))
                    ) : (
                      <option disabled>Carregando lista...</option>
                    )}
                  </SelectDefault>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={4}>
                  <InputDefault
                    placeholder="%"
                    Width={'100%'}
                    Margin={'15px 15px 15px 0px'}
                    value={prDesconto}
                    onChange={(e) => setPrDesconto(e.target.value)}
                    Text={'% de desconto da bandeira'}
                    type={'number'}
                  />
                </Col>
              </Row>
            </div>
          </Row>
          <Row>
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Salvar"
              onClick={() => {
                handleSendFlagEconomy();
              }}
            />
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Cancelar"
              onClick={() => {
                navigate('/flag_economy/list');
              }}
            />
          </Row>
        </ContainerClients>
        <ToastContainer />
      </Container>
      <Footer />
    </>
  );
};

export default FlagEconmomyAdd;
